import LoginComponent from '../login-component';
import FormActions from '../../logic/form-actions';

import {localize} from '../../infrastructure/localization';

import './forgot-password-link.scss';

export default class ForgotPasswordLink extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render () {
        return (
            <div className="forgot-password-placeholder">
                <a href="javascript:void(0)"
                   onClick={() => FormActions.redirectToForgotPwd(this.state.componentId)}>
                    {localize('form-components.forgot-password')}
                </a>
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/form-components/forgot-password-link.jsx
 **/